jQuery(document).ready(function($) {
	$('select[data-select-chain]').each(function(){
		
		// comportement attendu lors de la manipulation de l'élément
		$(this).on('change.select-chain-parent',selectChainParent)

		// on parcours ensuite les enfants
		childs = $(this).data('select-chain-childs');
		for(var i=0; i<childs.length; i++)
		{
			$child = $(childs[i]);

			// on met à jour la liste des parents
			var t = $child.data('select-chain-parents'); 
			t = t ? t:[]; t.push(this); 
			$child.data('select-chain-parents',t);

			// et on applique le comportement
			$child
				.off('change.select-chain-child')
				.on('change.select-chain-child',selectChainChild);
		}
		
	})
});

function selectChainParent(e,param)
{
	// on applique le filtrage aux enfants
	var k = $(this).data('select-chain');
	var v = $(this).val();
	var childs = $(this).data('select-chain-childs');
	for(var i=0; i<childs.length; i++)
	{
		var $child = $(childs[i]);
		$options = $child.find('option');
		$child.val('');
		$options.show();
		if(v!='')
			$options.filter(function() { return $(this).val()!='' && $(this).data(k)!=v; }).hide();
	}
}

function selectChainChild(e,param)
{
	var $option = $(this).find('option:selected');
	var parents = $(this).data('select-chain-parents');
	var filter = {};
	for(var i=0; i<parents.length; i++)
	{
		var $parent = $(parents[i]);
		var k = $parent.data('select-chain');
		var v = $option.data(k);
		$parent.val(v);

		if(v)
			filter[k] = v;
	}
	$options = $(this).find('option');
	$options.show();
	for(var i in filter)
		$options.filter(function() { return $(this).val()!='' && $(this).data(i)!=filter[i]; }).hide();
}